module.exports = __webpack_public_path__ + "72972aeeb7483f33ca09e5f205ebd2ca.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-56.png
// module id = 133
// module chunks = 0